import { AutoExecutableQuizRequest } from '@/models/AutoExecutableQuizRequest';
import { Quiz } from '@/models/Quiz';
import { QuizData } from '@/models/QuizData';
import { QuizQuestion } from '@/models/QuizQuestion';
import { QuizResult } from '@/models/QuizResult';
import { AxiosError } from 'axios';
import { action } from 'typesafe-actions';
import { QuizTypes } from './types';

export const clearQuiz = () => action(QuizTypes.CLEAR_QUIZ);

export const postQuizRequest = (quizData: QuizData) => action(QuizTypes.POST_QUIZ_REQUEST, quizData);
export const postQuizSuccess = (quizData: QuizData) => action(QuizTypes.POST_QUIZ_SUCCESS, quizData);
export const postQuizFailure = (error: AxiosError) => action(QuizTypes.POST_QUIZ_FAILURE, error);
export const getAutoExecutableQuizRequest = (request: AutoExecutableQuizRequest) => action(QuizTypes.GET_AUTO_EXECUTABLE_QUIZ_REQUEST, request);
export const getAutoExecutableQuizSuccess = (quiz: Quiz) => action(QuizTypes.GET_AUTO_EXECUTABLE_QUIZ_SUCCESS, quiz);
export const getAutoExecutableQuizFailure = (error: AxiosError) => action(QuizTypes.GET_AUTO_EXECUTABLE_QUIZ_FAILURE, error);

export const getQuizResultListRequest = (quizId: number) => action(QuizTypes.GET_QUIZ_RESULT_LIST_REQUEST, quizId);
export const getQuizResultListSuccess = (quizResultList: QuizResult[]) => action(QuizTypes.GET_QUIZ_RESULT_LIST_SUCCESS, quizResultList);
export const getQuizResultListFailure = (error: AxiosError) => action(QuizTypes.GET_QUIZ_RESULT_LIST_FAILURE, error);

export const getQuizResultRequest = (quizResultId: number) => action(QuizTypes.GET_QUIZ_RESULT_REQUEST, quizResultId);
export const getQuizResultSuccess = (quizResult: QuizResult) => action(QuizTypes.GET_QUIZ_RESULT_SUCCESS, quizResult);
export const getQuizResultFailure = (error: AxiosError) => action(QuizTypes.GET_QUIZ_RESULT_FAILURE, error);
export const postQuizResultRequest = (quizResult: QuizResult) => action(QuizTypes.POST_QUIZ_RESULT_REQUEST, quizResult);
export const postQuizResultSuccess = (quizResult: QuizResult) => action(QuizTypes.POST_QUIZ_RESULT_SUCCESS, quizResult);
export const postQuizResultFailure = (error: AxiosError) => action(QuizTypes.POST_QUIZ_RESULT_FAILURE, error);

export const getQuizQuestionListRequest = (quizId: number) => action(QuizTypes.GET_QUIZ_QUESTION_LIST_REQUEST, quizId);
export const getQuizQuestionListSuccess = (quizQuestionList: QuizQuestion[]) => action(QuizTypes.GET_QUIZ_QUESTION_LIST_SUCCESS, quizQuestionList);
export const getQuizQuestionListFailure = (error: AxiosError) => action(QuizTypes.GET_QUIZ_QUESTION_LIST_FAILURE, error);

export const postQuizQuestionRequest = (quizQuestion: QuizQuestion) => action(QuizTypes.POST_QUIZ_QUESTION_REQUEST, quizQuestion);
export const postQuizQuestionSuccess = (quizQuestion: QuizQuestion) => action(QuizTypes.POST_QUIZ_QUESTION_SUCCESS, quizQuestion);
export const postQuizQuestionFailure = (error: AxiosError) => action(QuizTypes.POST_QUIZ_QUESTION_FAILURE, error);

export const putQuizQuestionReorderRequest = (questionId: number, order: number) =>
    action(QuizTypes.PUT_QUIZ_QUESTION_REORDER_REQUEST, { questionId, order });
export const putQuizQuestionReorderSuccess = () => action(QuizTypes.PUT_QUIZ_QUESTION_REORDER_SUCCESS);
export const putQuizQuestionReorderFailure = (error: AxiosError) => action(QuizTypes.PUT_QUIZ_QUESTION_REORDER_FAILURE, error);
